(function () {
  function initSlider(sliderEl) {
    var frame = sliderEl.querySelector('.ba-slider__frame');
    var beforeWrap = sliderEl.querySelector('[data-ba-before-wrap]');
    var handle = sliderEl.querySelector('[data-ba-handle]');
    var range = sliderEl.querySelector('[data-ba-range]');

    if (!frame || !beforeWrap || !handle || !range) return;

    function setPosition(percent) {
      percent = Math.max(0, Math.min(100, percent));
      beforeWrap.style.width = percent + '%';
      handle.style.left = percent + '%';
      range.value = percent;

      var frameWidth = frame.getBoundingClientRect().width;
      beforeWrap.style.setProperty('--ba-frame-width', frameWidth + 'px');
    }

    setPosition(parseFloat(range.value) || 50);

    range.addEventListener('input', function (e) {
      setPosition(parseFloat(e.target.value));
    });

    var dragging = false;

    function percentFromClientX(clientX) {
      var rect = frame.getBoundingClientRect();
      var x = clientX - rect.left;
      return (x / rect.width) * 100;
    }

    function onPointerDown(e) {
      dragging = true;
      frame.classList.add('is-dragging');
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setPosition(percentFromClientX(clientX));
    }

    function onPointerMove(e) {
      if (!dragging) return;
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setPosition(percentFromClientX(clientX));
      if (e.cancelable) e.preventDefault();
    }

    function onPointerUp() {
      dragging = false;
      frame.classList.remove('is-dragging');
    }

    frame.addEventListener('mousedown', onPointerDown);
    window.addEventListener('mousemove', onPointerMove);
    window.addEventListener('mouseup', onPointerUp);

    frame.addEventListener('touchstart', onPointerDown, { passive: true });
    window.addEventListener('touchmove', onPointerMove, { passive: false });
    window.addEventListener('touchend', onPointerUp);

    window.addEventListener('resize', function () {
      setPosition(parseFloat(range.value));
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ba-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sliders = e.target.querySelectorAll('[data-ba-slider]');
    sliders.forEach(initSlider);
  });
})();